import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { initScrollDetection } from '../../utils/scrollDetection';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isQuizPage, setIsQuizPage] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Solo activar el efecto sticky en la página de inicio
    if (isHomePage) {
      const cleanup = initScrollDetection();
      
      // Cleanup function
      return cleanup;
    }
  }, [isHomePage]);
  
  useEffect(() => {
    // Detectar si es quiz page
    const checkForQuiz = () => {
      const quizElement = document.querySelector('.quiz-container');
      setIsQuizPage(!!quizElement);
    };
    
    // Detectar si es dispositivo móvil
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Verificar al inicio y cuando cambie la ruta
    checkForQuiz();
    checkIfMobile();
    
    // Verificar cada vez que haya cambios en el DOM
    const observer = new MutationObserver(checkForQuiz);
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Verificar cambios de tamaño
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [location]);
  
  // Si es página de quiz y dispositivo móvil, no mostrar el header
  if (isQuizPage && isMobile) {
    return null;
  }
  
  return (
    <header className={`header ${isHomePage ? 'sticky-header' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo-link">
          <div className="logo">
            <span className="logo-icon">🌡️</span>
            <span className="logo-text">Termómetro Emocional</span>
          </div>
        </Link>
        
        <div className="header-right">
          <a 
            href="https://tidycal.com/jesussagrario/15-minute-meeting" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-button"
          >
            Reservar cita psicólogo
          </a>
        </div>
      </div>
      
      {/* Se ha eliminado el badge de "Resultados listos" */}
    </header>
  );
};

export default Header;
